module.exports = __webpack_public_path__ + "static/media/Dual_5350.d8bc9402.jpg";